
import * as React from "react"
import { FormProvider } from "./FormProvider"
import { useForm } from "react-hook-form"

const Form = React.forwardRef<
  HTMLFormElement, 
  React.ComponentPropsWithoutRef<typeof FormProvider> & { 
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void
  }
>(({ children, onSubmit, ...props }, ref) => {
  return (
    <FormProvider {...props}>
      <form ref={ref} onSubmit={onSubmit}>
        {children}
      </form>
    </FormProvider>
  )
})
Form.displayName = "Form"

export { Form }
